module.exports = __webpack_public_path__ + "images/tour/lesson_plan_by_day_add_lesson-d6a8d36eab78a1f9b13733c97af911dd.gif";